var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7871 14.7585L11.6596 10.6311C12.5883 9.47207 13.0932 8.03063 13.0909 6.54545C13.0909 2.93055 10.1605 0 6.54544 0C2.93054 0 0 2.93055 0 6.54545C0 10.1604 2.93054 13.0909 6.54544 13.0909C8.09089 13.0909 9.51126 12.5553 10.6311 11.6595L14.7585 15.7869C14.826 15.8545 14.9061 15.9082 14.9943 15.9448C15.0826 15.9813 15.1772 16.0001 15.2727 16C15.4165 16 15.5571 15.9574 15.6767 15.8775C15.7963 15.7976 15.8896 15.684 15.9446 15.5511C15.9997 15.4182 16.0141 15.272 15.986 15.1309C15.958 14.9899 15.8888 14.8603 15.7871 14.7585ZM6.54544 11.6364C3.73381 11.6364 1.45454 9.35709 1.45454 6.54545C1.45454 3.73382 3.73381 1.45455 6.54544 1.45455C9.35726 1.45455 11.6363 3.73382 11.6363 6.54545C11.6363 9.35709 9.35726 11.6364 6.54544 11.6364Z",
    fill: "#CDCEC8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.8a7f7bdc.svg";
export { ForwardRef as ReactComponent };